import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  wrapIosSwitch: {
    display: 'flex',
    alignItems: 'center',
  },
  textPublicProfile: {
    fontSize: 14,
  },
  textFieldStyle: {
    '& .MuiInputBase-input': {
      padding: '12px 8px',
      backgroundColor: Colors.White,
    },
  },
}));

export default useStyles;
